<!-- 父级路由容器模板 -->

<template>
    <keep-alive :include="getCachedRoutePath">
        <router-view v-if="showRouteView" />
    </keep-alive>
</template>

<script>
import {
    mapGetters
} from 'vuex'

export default {
    name: 'others',
    computed: {
        ...mapGetters('global', ['getCachedRoutePath'])
    },
    data() {
        return {
            showRouteView: true
        }
    },
    activated() {
        this.showRouteView = true
    },
    deactivated() {
        this.showRouteView = false
    }
}
</script>
